/**
 * The three valid education program type slugs accepted by the backend.
 * The frontend owns the display labels; the backend renders the raw slug.
 */
export const PROGRAM_TYPE_OPTIONS = [
  { value: 'medical_school', label: 'Medical School' },
  { value: 'residency', label: 'Residency' },
  { value: 'fellowship', label: 'Fellowship' },
] as const;

export type EducationProgramTypeValue =
  (typeof PROGRAM_TYPE_OPTIONS)[number]['value'];
